/** Bit masks packed most significant bit first, eight cells to a byte, as servers send them. */
const BYTE_BITS = 8;
const HIGH_BIT = 0x80;

/** Bytes needed to hold `bitCount` bits. */
export function maskByteLength(bitCount: number): number {
    return Math.ceil(bitCount / BYTE_BITS);
}

export function isMaskBitSet(bytes: ArrayLike<number>, index: number): boolean {
    return ((bytes[Math.floor(index / BYTE_BITS)] ?? 0) &
        (HIGH_BIT >> (index % BYTE_BITS))) !== 0;
}

export function setMaskBit(bytes: Uint8Array, index: number): void {
    const at = Math.floor(index / BYTE_BITS);
    bytes[at] = (bytes[at] ?? 0) | (HIGH_BIT >> (index % BYTE_BITS));
}
